const requiredConfigs = [
  'REACT_APP_HOST',
  'REACT_APP_PROTOCOL',
  'REACT_APP_BACKEND_URL',
];

type Return = {
  baseUrl: string;
  backendUrl: string;
  backendApi: string;
  backendProxyTo?: string;
};

const getConfig = (): Return => {
  const getVars = () => {
    return process.env;
  };
  const vars = getVars();

  if (!vars) {
    throw new Error('No config vars found');
  }
  const configKeys = Object.keys(vars);

  const missingFields = requiredConfigs.filter(
    (field) => !configKeys.includes(field),
  );
  if (missingFields.length) {
    throw new Error(
      'The following required configuration fields are missing: ' +
        missingFields.toString(),
    );
  }
  const {
    REACT_APP_HOST: HOST,
    REACT_APP_PORT: PORT,
    REACT_APP_PROTOCOL: PROTOCOL,
    REACT_APP_BACKEND_URL: BACKEND_URL,
    REACT_APP_PROXY_BACKEND_TO: backendProxyTo,
    REACT_APP_ENVIRONMENT: envType,
  } = vars;

  if (
    typeof HOST !== 'string' ||
    typeof PROTOCOL !== 'string' ||
    typeof BACKEND_URL !== 'string'
  ) {
    throw new Error(
      'The following required configuration fields are missing: ' +
        missingFields.toString(),
    );
  }

  const getPort = (): string | undefined => {
    if (!envType || !['local', 'cypress'].includes(envType)) {
      return undefined;
    }

    return PORT;
  };

  const port = getPort();

  const getBaseUrl = (): string => {
    const allowedProtocols = ['http', 'https'];
    if (!allowedProtocols.includes(PROTOCOL)) {
      throw new Error(
        'PROTOCOL can only be one of: ' + allowedProtocols.toString(),
      );
    }

    return PROTOCOL + '://' + HOST + (port ? `:${port}` : '') + '/';
  };

  const baseUrl = getBaseUrl();

  const getBackendUrl = (): string => {
    if (backendProxyTo) {
      return baseUrl;
    }
    return BACKEND_URL;
  };
  const backendUrl = getBackendUrl();

  return {
    baseUrl,
    backendUrl,
    backendApi: backendUrl,
    backendProxyTo,
  };
};

export const { baseUrl, backendUrl, backendApi } = getConfig();

export default getConfig;
